/**
 * Opening the help panel from somewhere other than its own button (#1399).
 *
 * On mobile the launcher no longer has a button of its own -- Ask and Report a
 * bug are items in the plus menu instead -- so something has to be able to open
 * the panel from outside the component.
 *
 * An event rather than lifted state: HelpLauncher deliberately owns all of its
 * state so switching tabs or closing the panel never loses an in-flight chat or
 * a half-written bug report. Hoisting that into AppLayout to pass it back down
 * through two layers would put the thing most worth protecting in the component
 * least interested in it. This follows the existing CustomEvent precedent in
 * `api/http.ts` and `utils/swNavigationBridge.ts`.
 */

export const HELP_OPEN_EVENT = 'valentine:open-help';

export type HelpTab = 'ask' | 'report';

/** Open the help panel on a given tab. */
export function openHelp(tab: HelpTab) {
  window.dispatchEvent(new CustomEvent<HelpTab>(HELP_OPEN_EVENT, { detail: tab }));
}
